module.exports = __webpack_public_path__ + "static/media/efficient@2x.1180d5c4.png";